export default "__VITE_ASSET__50f2a69f__"